import React, { useState, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import { Link } from 'react-router-dom';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import Breadcrumb from 'src/components/Common/Breadcrumb';
import BreadcrumbWithFilter from 'src/components/Common/BreadcrumbWithFilter/BreadCrumbWithFilter';
import { useToast } from 'src/components/Common/ReactToaster';
import TicketHistoryLog from 'src/components/Common/TicketHistoryLog';
import ValidationPopup from 'src/components/Common/ValidationMessage/ValidationPopup';
import JobTooltipMEL from 'src/components/UI/JobTooltip';
import TooltipMEL from 'src/components/UI/Tooltip';
import { ROUTER } from 'src/constants/routes';
import TimeAgo from 'src/helpers/TimeAgo';
import FilePreviewModal from 'src/components/Common/FilePreviewModal';
import { formatDateTimeForHistoryView, formatDateTimeMEL, formatUtcToIstForHistoryView, hasAdminOrEmployeeRoleHandler, hasCustomerRoleHandler, hasDealerRoleHandler, hasFranchiseRoleHandler, hasManufacturerRoleHandler } from 'src/helpers/common_helpers';
import { closeTicketByEmployeeLoading, resolveTicketByEmployeeLoading, getEnquiryDocumentLinkLoading, getEnquiryUpoadedDocumentLoading, getInduvidualEnquiryLoading, getReplyMessageFromEmployeeLoading, getTicketHistoryLoading, reOpenTicketFromCustomerLoading, replyTheQueryLoading, resetEnquiryState, responseTheQueryLoading } from 'src/store/actions';
import { RootReducerState } from 'src/store/reducers';
import { Form, Formik } from 'formik';
import InputCom from 'src/components/Common/Input';
import Button from 'src/components/UI/Button';
import { useRef } from 'react';




const ViewTicketSystem = () => {

  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showToast } = useToast();
  const currentUser: any = localStorage.getItem("authUser");
  const parseUser = JSON.parse(currentUser);
  const { error, loading, induvidualEnquiry, enquiryDocument, replyMessages, message, ticketLog, enquiryDocumentLink } = useSelector((state: RootReducerState) => state.ticketSystemReducer);
  const { profile } = useSelector((state: RootReducerState) => state.profilesReducer);
  const [visible, setVisible] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState<any[]>([]);
  const [selectedReplyFiles, setSelectedReplyFiles] = useState<any[]>([]);
  const [isTooltipVisible, setIsTooltipVisible] = useState<boolean>(false);
  const [editTooltipVisible, setEditTooltipVisible] = useState<boolean>(false);
  const [showReply, setShowReply] = useState<boolean>(false);
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState<boolean>(false);
  const [previewData, setPreviewData] = useState<{ url: string, type: string, name: string } | null>(null);
  const replyFileInputRef = useRef<any>(null);
  const scroll = useRef<any>();
  const maxSizeInBytes = 5 * 1024 * 1024;
  // const replyMessage: any[] = [
  //   {
  //     name: "Ragu",
  //     createdOn: "April 21, 2024 at 11:40",
  //     description: "My audio part is not able to increase the volume",
  //     attachments: ["payment_screenshot.pdf", "payment_error_screenshot.pdf"],
  //     className: "message-align-left"
  //   },
  //   {
  //     name: "Sangeeth Rajan",
  //     createdOn: "April 21, 2024 at 11:40",
  //     description: "My audio part is not able to increase the volume",
  //     className: "message-align-right"
  //   },
  //   {
  //     name: "Karthik Pandin",
  //     createdOn: "April 21, 2024 at 11:40",
  //     description: "My audio part is not able to increase the volume",
  //     className: "message-align-left"
  //   },
  // ]

  useEffect(() => {
    if (message) {
      showToast(message, { type: "success" });
      if (induvidualEnquiry) {
        dispatch(getReplyMessageFromEmployeeLoading(induvidualEnquiry?.id))
        dispatch(getTicketHistoryLoading(induvidualEnquiry?.id))
      }
      if (id) {
        dispatch(getInduvidualEnquiryLoading(id))
        dispatch(getEnquiryUpoadedDocumentLoading(id, "Enquiry"))
      }
    }
  }, [message])

  const replyMessage = useMemo(() => {
    return [
      {
        name: induvidualEnquiry?.customerName ? induvidualEnquiry?.customerName : "testUser",
        createdOn: formatDateTimeMEL(induvidualEnquiry?.creationTime),
        description: induvidualEnquiry?.description.split('\r\n')[1],
        attachments: enquiryDocument?.length > 0 ? enquiryDocument?.map((data: any) => {
          let object = {
            name: data.name,
            id: data.id
          }
          return object
        }) : [],
        className: "message-align-left"
      },
    ];
  }, [induvidualEnquiry, enquiryDocument]);



  const editData: any = {
    categoryName: induvidualEnquiry?.category,
    subject: induvidualEnquiry?.subject,
    description: induvidualEnquiry?.description,
    supporterName: induvidualEnquiry?.supporterName,
    status: induvidualEnquiry?.status,
    priority: induvidualEnquiry?.priority,
    createdOn: formatUtcToIstForHistoryView(induvidualEnquiry?.creationTime || ""),
    dueDate: induvidualEnquiry?.dueDate ? formatDateTimeMEL(induvidualEnquiry?.dueDate) : "",
    completedDate: induvidualEnquiry?.completedDate ? formatDateTimeMEL(induvidualEnquiry?.completedDate) : "",
    number: induvidualEnquiry?.number || "",
    isCompletedWithinDueDate: induvidualEnquiry?.isCompletedWithinDueDate,
    attachement: induvidualEnquiry?.documents.map((data) => {
      let object = {
        name: data.name,
        type: data.mimeType,
        id: data.id
      }
      return object
    })
  }

  const hidePopup = () => {
    setVisible(false);
    // dispatch(resetEnquiryState())
  }
  useEffect(() => {
    if (induvidualEnquiry) {
      dispatch(getReplyMessageFromEmployeeLoading(induvidualEnquiry?.id))
      dispatch(getTicketHistoryLoading(induvidualEnquiry?.id))
    }
  }, [induvidualEnquiry])

  const dialogContainer = (error: any) => {
    return (
      <>
        <ValidationPopup error={error} visible={visible} onHide={hidePopup} />
      </>
    );
  };

  useEffect(() => {
    dispatch(getInduvidualEnquiryLoading(id))
    dispatch(getEnquiryUpoadedDocumentLoading(id, "Enquiry"))
  }, [id])

  useEffect(() => {
    const preloader: any = document.getElementById("preloader");
    if (loading) {
      preloader.style.display = "block";
    } else {
      preloader.style.display = "none";
    }
  }, [loading]);

  useEffect(() => {
    if (error) {
      setVisible(true);
    }
  }, [error])

  const createEnqiuiryDocumentLink = (id: string) => {
    dispatch(getEnquiryDocumentLinkLoading(id))
  }

  useEffect(() => {
    if (enquiryDocumentLink != "" && enquiryDocumentLink != undefined && enquiryDocumentLink != null) {
      if (previewData) {
        setPreviewData(prev => prev ? { ...prev, url: enquiryDocumentLink } : null);
        setIsPreviewModalOpen(true);
      } else {
        const newWindow = window.open(enquiryDocumentLink)
        if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
          alert('Popup blocked! Please allow popups for this site to view the document.');
        } else {
          newWindow.focus();
        }
      }
      dispatch(resetEnquiryState())
    }
  }, [enquiryDocumentLink])

  const handlePreview = (id: string, type: string, name: string) => {
    setPreviewData({ url: "", type, name });
    dispatch(getEnquiryDocumentLinkLoading(id));
  };

  const openDocumet = (id: string) => {
    dispatch(getEnquiryDocumentLinkLoading(id))
  }

  const combinedMessages = replyMessages?.map(data => {
    const isCustomer = data.isCustomer;
    const classDecide = data.creatorId;
    const name = isCustomer ? data.customerName : (data.supporterName ? data.supporterName : "test");
    // const className = isCustomer ? "message-align-right" : "message-align-left";
    const className = (classDecide == parseUser?.uid) ? "message-align-right" : "message-align-left";
    const messageClass = (classDecide == parseUser?.uid) ? "message-box-container" : "message-box-container_response"

    return {
      name: name,
      createdOn: <TimeAgo timeStamp={data.creationTime} />,
      description: data.description,
      className: className,
      attachments: data.documents.length > 0 ? data.documents.map(doc => ({
        name: doc.name,
        id: doc.id,
        type: doc.mimeType
      })) : [],
      messageClass: messageClass
    };
  });

  const isImageMimeType = (mimeType: any) => {
    const imageMimeTypes = /^image\/(png|jpeg|jpg|gif|svg\+xml|bmp|webp|tiff|ico)$/;
    return imageMimeTypes.test(mimeType);
  }

  const relpyHandlerAddClick = () => {
    replyFileInputRef.current.click()
  }

  const allRoles = hasCustomerRoleHandler() || hasFranchiseRoleHandler() || hasManufacturerRoleHandler()

  const sendHandler = (values: any, setFieldValue: any, setFieldTouched: any) => {
    debugger
    let { reply } = values;
    if (!reply) {
      setFieldTouched('reply', 'Username is required.');
      return
    }
    let submittedData = {
      Description: reply,
      ParentReplyId: replyMessages?.length > 0 && replyMessages[replyMessages.length - 1].id ? replyMessages[replyMessages.length - 1].id : null,
      FormFiles: selectedReplyFiles,
    }
    if (allRoles) {
      dispatch(replyTheQueryLoading(id, submittedData))
    } else {
      dispatch(responseTheQueryLoading(id, submittedData))
    }
    setFieldValue("reply", "")
    setSelectedReplyFiles([])
    setShowReply(false)
  }

  const colseTicketHandle = () => {
    dispatch(closeTicketByEmployeeLoading(id))
  }

  const resolveTicketHandle = () => {
    dispatch(resolveTicketByEmployeeLoading(id))
  }

  useEffect(() => {
    scroll.current?.scrollIntoView({ behavior: "smooth" });
  }, [replyMessages])

  const initialvalue = useMemo(() => {
    return {
      reply: "",
    }
  }, [])

  return (
    <React.Fragment>
      {visible && dialogContainer(error)}
      <div className="page-content" id="ticket-system">
        <Container fluid>
          <BreadcrumbWithFilter
            title="Ticket system"
            titlePath={ROUTER.TICKET_SYSTEM}
            breadcrumbItem={"View Ticket System"}
            isShowCreate={false}
            isShowFilter={false}
            filter={false}
            isShowFirstButton={(induvidualEnquiry?.status == "Closed")}
            firstButtonLabel={"Reopen Ticket"}
            onFirstButtonClick={() => {
              dispatch(reOpenTicketFromCustomerLoading(id))
            }}
          />

          <Row>
            <div className="general-details">
              <b>Ticket Details</b>
            </div>
            <Card>
              {/* <CardBody className='container'> */}
              <CardBody className=''>
                <Formik
                  onSubmit={() => { }}
                  initialValues={initialvalue}
                  enableReinitialize>
                  {({ values, handleChange, touched, errors, handleBlur, setFieldValue, setFieldTouched }: any) => {
                    return (
                      <Form onChange={handleChange}>
                        <React.Fragment>
                          <Row>
                            {id &&
                              <>
                                <div className="view-details-container">
                                  <div className={` pt-3 viewTicketCls`}>
                                    <div>Ticket Number</div>
                                    <div className='childTicket'>:</div>
                                    <div className='weight-700'>{editData['number'] || "-"}</div>
                                  </div>
                                  <div className={` pt-3 viewTicketCls`}>
                                    <div>Category</div>
                                    <div className='childTicket'>:</div>
                                    <div className='weight-700'>{editData['categoryName']}</div>
                                  </div>
                                  <div className={` pt-3 viewTicketCls`}>
                                    <div>Subject</div>
                                    <div className='childTicket'>:</div>
                                    <div className='weight-700'>{editData['subject']}</div>
                                  </div>

                                  <div className={` pt-3 viewTicketCls`}>
                                    <div>Status</div>
                                    <div className='childTicket'>:</div>
                                    <div className='weight-700'>{editData['status']}</div>
                                  </div>

                                  <div className={` pt-3 viewTicketCls`}>
                                    <div>Priority</div>
                                    <div className='childTicket'>:</div>
                                    <div className='weight-700'>{editData['priority']}</div>
                                  </div>

                                  <div className={` pt-3 viewTicketCls`}>
                                    <div>Description</div>
                                    <div className='childTicket'>:</div>
                                    <div className='weight-700'>{editData['description']}</div>
                                  </div>
                                  <div className={` pt-3 viewTicketCls`}>
                                    <div>Assigned To</div>
                                    <div className='childTicket'>:</div>
                                    <div className='weight-700'>{editData['supporterName']}</div>
                                  </div>
                                  <div className={` pt-3 viewTicketCls`}>
                                    <div>Created On</div>
                                    <div className='childTicket'>:</div>
                                    <div className='weight-700'>{editData['createdOn']}</div>
                                  </div>
                                  <div className={` pt-3 viewTicketCls`}>
                                    <div>Due Date</div>
                                    <div className='childTicket'>:</div>
                                    <div className='weight-700'>{editData['dueDate'] || "-"}</div>
                                  </div>
                                  <div className={` pt-3 viewTicketCls`}>
                                    <div>Completed Date</div>
                                    <div className='childTicket'>:</div>
                                    <div className='weight-700'>{editData['completedDate'] || "-"}</div>
                                  </div>
                                  <div className={` pt-3 viewTicketCls`}>
                                    <div>Is Completed Within Due Date</div>
                                    <div className='childTicket'>:</div>
                                    <div className='weight-700'>
                                      {editData['isCompletedWithinDueDate'] === true ? "👍" : editData['isCompletedWithinDueDate'] === false ? "👎" : "-"}
                                    </div>
                                  </div>

                                  <div className={` pt-3 viewTicketCls`}>
                                    <div>Attachements</div>
                                    <div className='childTicket'>:</div>
                                    <div className='weight-700'>
                                      <div className='editedDate_file'>
                                        {
                                          editData?.attachement?.length > 0 ? editData?.attachement?.map((data: any, i: number) => {
                                            if (data.type == "application/pdf") {
                                              return (
                                                <JobTooltipMEL key={i} title={data.name} position='bottom'>
                                                  <i onClick={() => handlePreview(data.id, data.type, data.name)} className="fas fa-file-pdf"></i>
                                                </JobTooltipMEL>
                                              )
                                            } else if (data.type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || data.type == "application/vnd.ms-excel") {
                                              return (
                                                <JobTooltipMEL key={i} title={data.name} position='bottom'>
                                                  <i key={i} onClick={() => handlePreview(data.id, data.type, data.name)} className="fas fa-file-csv"></i>
                                                </JobTooltipMEL>
                                              )
                                            } else if (isImageMimeType(data.type)) {
                                              return (
                                                <JobTooltipMEL key={i} title={data.name} position='bottom'>
                                                  <i key={i} onClick={() => handlePreview(data.id, data.type, data.name)} className="fas fas fa-image"></i>
                                                </JobTooltipMEL>
                                              )
                                            } else {
                                              return (
                                                <JobTooltipMEL key={i} title={data.name} position='bottom'>
                                                  <i key={i} onClick={() => handlePreview(data.id, data.type, data.name)} className="fas fa-file-alt"></i>
                                                </JobTooltipMEL>
                                              )
                                            }
                                          }) : <span style={{ fontSize: "14px" }}>No attachement here</span>
                                        }
                                      </div>
                                    </div>
                                  </div>
                                  {
                                    induvidualEnquiry?.parentId && <><div className={` pt-3 viewTicketCls`}>
                                      <div>Check prevoius conversation</div>
                                      <div className='childTicket'>:</div>
                                      <Link to={ROUTER.VIEW_TICKET_SYSTEM + "/" + induvidualEnquiry?.parentId} >Show</Link>
                                    </div>
                                    </>
                                  }
                                </div>
                              </>
                            }
                            {selectedFiles?.length > 0 && <Col lg={12}>
                              <div className='selected-file-container'>
                                <h5>Selected Files</h5>
                                <div className=''>
                                  <Row>
                                    {selectedFiles.map((eachValues: any, index: number) => {
                                      return (<Col lg={6} key={eachValues.name + index}>
                                        <div className='reply-attachment-container'>
                                          <div>{eachValues.name}</div>
                                          <div><i className="far fa-trash-alt selected-file-delete-icon" onClick={() => {
                                            setSelectedFiles((prevFiles: any[]) => {
                                              let data: any = [...prevFiles];
                                              data = data.filter((eachFiles: any, fileIndex: number) => fileIndex != index);
                                              return data;
                                            })
                                          }}></i></div>
                                        </div>
                                      </Col>)
                                    })}
                                  </Row>
                                </div>
                              </div>
                            </Col>}
                          </Row>
                          {(id && replyMessages?.length > 0) && <Row className='reply-container'>
                            <div ref={scroll}>
                              {combinedMessages.map((eachMessage: any, index: number) => {
                                return (
                                  <div key={index} className={eachMessage.className}>
                                    <div className='message-sender-container'>
                                      <div className="weight-700">{eachMessage?.name}</div>
                                      <div className='message-box-date'>{eachMessage?.createdOn}</div>
                                    </div>
                                    <div className={eachMessage.messageClass}>
                                      {eachMessage?.description}
                                    </div>
                                    <div className='file_structures'>
                                      {
                                        eachMessage?.attachments?.map((data: any, i: number) => {
                                          if (data.type == "application/pdf") {
                                            return (
                                              <JobTooltipMEL key={i} title={data.name} position='bottom'>
                                                <i onClick={() => handlePreview(data.id, data.type, data.name)} className="fas fa-file-pdf"></i>
                                              </JobTooltipMEL>
                                            )
                                          } else if (data.type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                                            return (
                                              <JobTooltipMEL key={i} title={data.name} position='bottom'>
                                                <i key={i} onClick={() => handlePreview(data.id, data.type, data.name)} className="fas fa-file-csv"></i>
                                              </JobTooltipMEL>
                                            )
                                          } else if (isImageMimeType(data.type)) {
                                            return (
                                              <JobTooltipMEL key={i} title={data.name} position='bottom'>
                                                <i key={i} onClick={() => handlePreview(data.id, data.type, data.name)} className="fas fas fa-image"></i>
                                              </JobTooltipMEL>
                                            )
                                          } else {
                                            return (
                                              <JobTooltipMEL key={i} title={data.name} position='bottom'>
                                                <i key={i} onClick={() => handlePreview(data.id, data.type, data.name)} className="fas fa-file-alt"></i>
                                              </JobTooltipMEL>
                                            )
                                          }
                                        })
                                      }
                                    </div>
                                    <div>
                                    </div>
                                  </div>)
                              })}
                            </div>
                          </Row>}
                          {id && <Row className='reply-container mt-2'>
                            {!showReply && <Col lg={12}>
                              <div className='attachment-container'>
                                <div>Reply </div>
                                <div className='attachment-icon'><i className="fas fa-plus-circle" onClick={() => { setShowReply(true) }}></i></div>
                              </div>
                            </Col>}
                            {showReply && <Col lg={12}>
                              <InputCom
                                labelName=""
                                inputclassName="form-control"
                                labelClassName="form-Label"
                                type="textarea"
                                name="reply"
                                onBlur={handleBlur}
                                value={values.reply}
                                onChange={handleChange}
                                isRequired={false}
                                rowHeight={6}
                                invalid={touched["reply"] && errors["reply"] ? true : false}
                              />
                              <div className='reply-sent-container'>
                                <div className='attachment-container'>
                                  <div>Attachment </div>
                                  <div className='attachment-icon'><i className="fas fa-plus-circle" onClick={relpyHandlerAddClick}></i></div>
                                  <input
                                    type="file"
                                    multiple
                                    ref={replyFileInputRef}
                                    style={{ display: 'none' }}
                                    onChange={(e: any) => {
                                      const files = Array.from(e.target.files);
                                      const validFiles = files.filter((file: any) => file.size <= maxSizeInBytes);
                                      if (validFiles.length !== files.length) {
                                        showToast(`Some files were too large and have been excluded. The maximum file size is ${maxSizeInBytes / 1024 / 1024} MB.`, { type: "error" });
                                        replyFileInputRef.current.value = '';
                                        return
                                      }
                                      setSelectedReplyFiles((prevValue: any[]) => {
                                        let files: any[] = [...prevValue];
                                        files = [...files, ...e.target.files];
                                        return files
                                      })
                                    }}
                                  />
                                </div>
                                <div className='reply-sent-btn-container'>
                                  <div className='attachment-container '>
                                    <div className='send-btn' onClick={() => setShowReply(false)}>Close <i className='fas fa-times-circle'></i> </div>
                                    <div className='attachment-icon'></div>
                                  </div>
                                  <div className='attachment-container '>
                                    <div className='send-btn' onClick={() => sendHandler(values, setFieldValue, setFieldTouched)}>Send <i className='fas fa-paper-plane'></i> </div>
                                    <div className='attachment-icon'></div>
                                  </div>
                                </div>

                              </div>
                              <div className='reply-attachment-alignment'>
                                <Row>
                                  {selectedReplyFiles.map((eachValues: any, index: number) => {
                                    return (<Col lg={6} key={eachValues.name + index}>
                                      <div className='reply-attachment-container'>
                                        <div>{eachValues.name}</div>
                                        <div><i className="far fa-trash-alt selected-file-delete-icon" onClick={() => {
                                          setSelectedReplyFiles((prevFiles: any[]) => {
                                            let data: any = [...prevFiles];
                                            data = data.filter((eachFiles: any, fileIndex: number) => fileIndex != index);
                                            replyFileInputRef.current.value = '';
                                            return data;
                                          })
                                        }}></i></div>
                                      </div>
                                    </Col>)
                                  })}
                                </Row>
                              </div>


                            </Col>}
                          </Row>}
                          {id && ticketLog && ticketLog.length > 0 && (
                            <TicketHistoryLog
                              ticketLog={ticketLog}
                              title="Ticket History"
                            />
                          )}
                          <div className='d-flex justify-content-end mb-2'>
                            {
                              ((induvidualEnquiry?.status != "Closed" && id) && (profile?.extraProperties?.IsAdmin == true || profile?.extraProperties?.IsSuperAdmin == true)) &&
                              <Button
                                className="btn-primary me-2 btn-primary-shadow"
                                label="Close Ticket"
                                type="button"
                                onClick={colseTicketHandle}
                              />
                            }
                            {
                              ((induvidualEnquiry?.status != "Resolved" && induvidualEnquiry?.status != "Closed" && id) && (hasAdminOrEmployeeRoleHandler() || allRoles)) &&
                              <Button
                                className="btn-primary me-2 btn-primary-shadow"
                                label="Resolve Ticket"
                                type="button"
                                onClick={resolveTicketHandle}
                              />
                            }
                          </div>
                        </React.Fragment>
                      </Form>
                    )
                  }}
                </Formik>
              </CardBody>
            </Card>
          </Row>
        </Container>
        <FilePreviewModal
          isOpen={isPreviewModalOpen}
          toggle={() => setIsPreviewModalOpen(false)}
          fileUrl={previewData?.url || ""}
          fileType={previewData?.type || ""}
          fileName={previewData?.name || ""}
        />
      </div>
    </React.Fragment>
  )
}

export default ViewTicketSystem